import style from "../GameFieldOffCanvasCustomMove.module.css";
import commonStyle from "../Style.module.css";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import * as GroupGameService from "../../api/GroupGameService";

export default function GroupGameFieldOffCanvasGameSettings(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'gameFieldOffCanvasSettings' });
    const [folded, setFolded] = useState(true)

    const selectedPlayer = getSelectedPlayerData(props.selectedPlayerId)

    const [highlight, setHighlight] = useState(selectedPlayer.player_settings.game_view_highlight_steps)
    const [allowView, setAllowView] = useState(selectedPlayer.player_settings.game_view_enable_view_all_cells)

    function getSelectedPlayerData(playerId) {
        for (const player of props.gameState.players) {
            if (player.id === playerId) {
                return player
            }
        }
    }

    function changeHighLight() {
        setHighlight(!highlight)
        GroupGameService.setUserGroupGameViewSettings(props.gameState.id, props.selectedPlayerId, !highlight, null, () => {}, () => {})
    }

    function changeAllowView(event) {
        if (event.target.value === "all") {
            setAllowView(true)
            GroupGameService.setUserGroupGameViewSettings(props.gameState.id, props.selectedPlayerId, null, true, () => {}, () => {})
        } else {
            setAllowView(false)
            GroupGameService.setUserGroupGameViewSettings(props.gameState.id, props.selectedPlayerId, null, false, () => {}, () => {})
        }
    }

    return <div className={style.container} >
        <header
            onClick={() => {setFolded(!folded)}}
            className={commonStyle.h5Heading}
            style={{cursor: "pointer"} }
        >{t('gameSettingsLabel')} {folded ? <KeyboardDoubleArrowDownIcon/> : <KeyboardDoubleArrowUpIcon/>}</header>
        <div
            style={{display: folded ? "none" : "block"}}
        >
            <div style={{display:"flex", flexDirection:"row", gap: "6px"}}>
                <input type="checkbox" checked={highlight} onClick={changeHighLight}/>
                <div style={{padding: "3px", fontSize: "16px"}}> {t('highlightUserStepsLabel')}</div>
            </div>

            <div style={{display:"flex", flexDirection:"column", gap: "6px"}}>
                <fieldset style={{border: "solid black 0.5px", borderRadius: "6px", paddingLeft: "6px"}}>
                    <div style={{display:"flex", flexDirection:"row", gap: "6px"}}>
                        <input type="radio" id="allow-path" name="allow-cards" value="path" checked={!allowView} onChange={changeAllowView}/>
                        <label htmlFor="huey">{t('allowViewAllLabel2')} <b>{t('allowOnlyPathTooltip')}</b></label>
                    </div>
                    <hr style={{borderTop: "dashed 0.5px black"}}/>
                    <div style={{display:"flex", flexDirection:"row", gap: "6px"}}>
                        <input type="radio" id="allow-all" name="allow-cards" value="all" checked={allowView} onChange={changeAllowView}/>
                        <label htmlFor="dewey">{t('allowViewAllLabel2')} <b>{t('allowAllFieldsTooltip')}</b></label>
                    </div>
                </fieldset>
            </div>

        </div>
    </div>
}